<template>
  <td colspan="6">
    <div class="class-table" @mouseenter.prevent="actionShowIcon" @mouseleave="actionHideIcon">
      <div class="table-row">
        <!--列1：用户名-->
        <div class="table-cell cell-1">
          <el-select class="select-user"
                     v-model="selectUser"
                     value-key="id"
                     placeholder="请选择"
                     @change="onChangeUser"
                     size="small">
            <el-option v-for="item in userLists"
                       :key="item.id"
                       :label="item.name"
                       :value="item">
            </el-option>
          </el-select>
        </div>
        <!--列2：文件名称-->
        <div class="table-cell cell-2">
          <div class="stored-name-cell">
            <span class="stored-edit" @click="onOpenFile(file.name, file.type)" :title="file.name">
              {{ file.name }}
            </span>
            <!--                        下载和删除按钮-->
            <div v-show="showIcon" class="stored-download"  ><!--@click="encodeUrl(file.name)"-->
              <span @click="encodeUrl(file.name)">
                <!--                            <img class="icon" src="../assets/images/download-51.png" alt="下载" title="下载" />-->
                <img :src="iconSrcList.download" alt="下载" title="下载" class="icon"
                     @mouseenter="actionToggleSrc('download', true)"
                     @mouseleave="actionToggleSrc('download', false)" />
              </span>
              <span class="delete-file" @click="actionDelete">
                <!--                            <img class="icon" src="../assets/images/delete-51.png" alt="删除" title="删除" />-->
                <img :src="iconSrcList.delete" alt="删除" title="删除" class="icon"
                     @mouseenter="actionToggleSrc('delete', true)"
                     @mouseleave="actionToggleSrc('delete', false)" />
              </span>
              <!-- <span @click="dialogFormVisible1=true">
                  文档比较
              </span> -->
            </div>
          </div>
          <div v-show="file.type === 'text'">
            <button @click="dialogFormVisible1=true">
                  文档比较
              </button>
              <button @click="dialogFormVisible2=true">
                  水印设置
              </button>
          </div>
        </div>
        <!-- 文档比较弹出框 -->
        <el-dialog
                :visible.sync="dialogFormVisible1"
                :close-on-click-modal="false"
                v-dialogDrag:{dialogDrag}="dialog.dialogDrag"
                v-dialogChange:{dialogChange}="dialog.dialogChange"
                width="600px"
        >
            <template slot="title">
                <div>请输入文档比较地址</div>
            </template>
            <el-tabs>
                <el-tab-pane label="文档地址">
                    <div>实例：http://sdk.51changxie.com/demo/OEMContract.docx</div>
                    <el-tabs>
                        <el-input 
                                type="input"
                                :rows="9"
                                placeholder="请输入地址"
                                v-model="textarea1"
                                style="height: 219px"
                        >
                        </el-input>
                    </el-tabs>
                </el-tab-pane>
            </el-tabs>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible1 = false" size="small" class="dialog-button">取 消</el-button>
                <el-button type="primary"
                           @click="Compare"
                           size="small"
                           class="dialog-button"
                           :disabled="!textarea1">确 定</el-button>
            </div>
            <div>

            </div>

        </el-dialog>
        <!-- 水印设置弹出框 -->
        <el-dialog
                :visible.sync="dialogFormVisible2"
                :close-on-click-modal="false"
                v-dialogDrag:{dialogDrag}="dialog.dialogDrag"
                v-dialogChange:{dialogChange}="dialog.dialogChange"
                width="510px"
                height="500px"
        >
            <div style="height:510px;overflow-x:auto;overflow-y:auto">
              <template slot="title">
                <div class="dialog4-title">水印设置</div>
            </template>
            <el-form>
                <el-form-item label="透明度" class="font-width1">
                    <el-input v-model="transparent" placeholder="请输入0-1的数字"></el-input>
                </el-form-item>
                <el-form-item label="水印类型" class="font-width2">
                <el-select v-model="shape" placeholder="请选择水印类型">
                    <el-option
                    v-for="item in shapes"
                    :key="item.shape"
                    :label="item.label"
                    :value="item.shape">
                    </el-option>
                </el-select>
                </el-form-item>
            </el-form>
              <el-form>
                <el-form-item label="水印宽度" class="font-width1">
                    <el-input v-model="waterWidth" placeholder="输入数字即可，单位为mm"></el-input>
                </el-form-item>
                <el-form-item label="水印高度" class="font-width2">
                    <el-input v-model="waterHeight" placeholder="输入数字即可，单位为mm"></el-input>
                </el-form-item>
            </el-form>
            
            <el-form>
                <el-form-item label="水印旋转角度" class="font-width1">
                    <el-input v-model="rotate" placeholder="正数向右旋转，负数向左旋转"></el-input>
                </el-form-item>
                <el-form-item label="段落距边框的留白区域" class="font-width2">

                    <el-input v-model="margins" placeholder="[左,上,右,下]"></el-input>
                </el-form-item>
            </el-form>
            <el-form>
                <el-form-item label="水印填充颜色" class="font-width1">
                    <el-input v-model="fill" placeholder="输入水印填充颜色(255,0,0)"></el-input>
                </el-form-item>
                <el-form-item label="垂直方向文本对齐方式" class="font-width2">
                  <el-select v-model="fond" placeholder="请选择">
                    <el-option
                    v-for="item in fonds"
                    :key="item.fond"
                    :label="item.label"
                    :value="item.fond">
                    </el-option>
                </el-select>
                </el-form-item>
            </el-form>
            <el-form>
                <el-form-item label="描边颜色" class="font-width1">
                    <el-input v-model="stroke" placeholder="255,0,0"></el-input>
                </el-form-item>
                <el-form-item label="描边宽度" class="font-width2">
                    <el-input v-model="strokeWidth" placeholder="输入数字即可，单位为mm"></el-input>
                </el-form-item>
            </el-form>
            <el-form>
                <el-form-item label="水平方向文本对齐方式" class="font-width1">
                  <el-select v-model="Wfond" placeholder="请选择">
                    <el-option
                    v-for="item in Wfonds"
                    :key="item.Wfond"
                    :label="item.label"
                    :value="item.Wfond">
                    </el-option>
                </el-select>
                </el-form-item>
                <el-form-item label="段落背景色" class="font-width2">
                    <el-input v-model="Wfill" placeholder="255,0,0"></el-input>
                </el-form-item>
            </el-form>
            <el-form>
                <el-form-item label="行距" class="font-width1">
                    <el-input v-model="linespacing" placeholder="行距为多倍行距"></el-input>
                </el-form-item>
                <el-form-item label="文字内容" class="font-width2">
                    <el-input v-model="text" placeholder="请输入内容"></el-input>
                </el-form-item>
            </el-form>
            <!-- <div class="block">
              <span class="demonstration">文字颜色</span>
              <el-color-picker v-model="fontColor"></el-color-picker>
            </div> -->
            <el-form>
                <el-form-item label="文字颜色" class="font-width1">
                    <el-input v-model="fontColor" placeholder="255,0,0"></el-input>
                </el-form-item>
                <el-form-item label="字体属性" class="font-width2">
                    <el-input v-model="fontFamily" placeholder="文字使用的字体属性"></el-input>
                </el-form-item>
            </el-form>
            <el-form>
                <el-form-item label="文字字号" class="font-width1">
                    <el-input v-model="fontSize" placeholder="输入数字即可"></el-input>
                </el-form-item>
                <el-form-item  class="font-width2">
                    <el-checkbox v-model="bold">粗体</el-checkbox>
                    <el-checkbox v-model="italic">斜体</el-checkbox>
                    <el-checkbox v-model="strikeout">删除线</el-checkbox>
                    <el-checkbox v-model="underline">下划线</el-checkbox>
                </el-form-item>
            </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible2 = false" size="small" class="dialog-button">取 消</el-button>
                <el-button type="primary"
                           @click="waterMarks"
                           size="small"
                           class="dialog-button"
                           >确 定</el-button>
            </div>
            
        </el-dialog>
        <!--列3：视图控制复选框-->
        <div class="table-cell cell-3">
          <div class="table-cell-view">
            <el-checkbox-group v-model="viewCtrlCheckList" class="checkbox-view">
              <el-checkbox label="工具栏"></el-checkbox>
              <el-checkbox label="左侧面板"></el-checkbox>
              <el-checkbox label="状态栏"></el-checkbox>
              <el-checkbox label="右侧面板"></el-checkbox>
            </el-checkbox-group>
            <el-dropdown @command="actionCommand" :hide-on-click="false" v-show="file.type === 'text'">
              <span class="el-dropdown-link">
                修订查看模式<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item class="el-dropdown-item" command=0>
                  <div class="el-icon-check" v-show="this.selectReviewDisplay === 'markup'"></div>
                  <div class="icon-width" v-show="this.selectReviewDisplay !== 'markup'"></div>
                  标记状态
                </el-dropdown-item>
                <el-dropdown-item class="el-dropdown-item" command=1>
                  <div class="el-icon-check" v-show="this.selectReviewDisplay === 'final'"></div>
                  <div class="icon-width" v-show="this.selectReviewDisplay !== 'final'"></div>
                  最终状态
                </el-dropdown-item>
                <el-dropdown-item class="el-dropdown-item" command=2>
                  <div class="el-icon-check" v-show="this.selectReviewDisplay === 'original'"></div>
                  <div class="icon-width" v-show="this.selectReviewDisplay !== 'original'"></div>
                  原始状态
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <!--                列4：权限控制复选框-->
        <div class="table-cell cell-4">
          <el-checkbox-group v-model="permissionCheckList">
            <el-checkbox label="禁止下载"></el-checkbox>
            <el-checkbox label="禁止打印"></el-checkbox>
            <el-checkbox label="禁止跨文档复制"></el-checkbox>
          </el-checkbox-group>
        </div>
        <!--                列5：协作模式组合单选框-->
        <div class="table-cell cell-5">
          <div>
            <span class="label-css">编辑模式</span>
            <div class="icon-container">
              <span class="editor-config"
                    v-for="(mode, index) in editIconList" v-bind:key="index"
                    v-if="mode.isShow.indexOf(file.type) > -1">
                <img class="icon"
                     :src="mode.source" :alt="mode.title" :title="mode.title"
                     @mouseenter="changeIconSrc(mode.mode, true)"
                     @mouseleave="changeIconSrc(mode.mode, false)"
                     @click="actionToggleIcon(mode.mode, true)" />
              </span>
            </div>
          </div>
          <div>
            <span class="label-css">查看模式</span>
            <div class="icon-container">
              <span class="editor-config"
                    v-for="(mode, index) in previewIconList" v-bind:key="index"
                    v-if="mode.isShow.indexOf(file.type) > -1">
                <img class="icon"
                     :src="mode.source" :alt="mode.title" :title="mode.title"
                     @mouseenter="changeIconSrc(mode.mode, true)"
                     @mouseleave="changeIconSrc(mode.mode, false)"
                     @click="actionToggleIcon(mode.mode, index)" />
              </span>
            </div>
          </div>
        </div>
        <!--                列6：源码-->
        <div class="table-cell cell-6">
          <div class="icon-container">
            <div  title="Demo源码" class="icon-code" />
          </div>
        </div>
      </div>

    </div>
   
  </td>
  <!-- 文档比较弹出框 -->
  

</template>

<script>
    import axios from "axios";
    export default {
        name: "fileItem",
        props: ['file'],
        data:function () {
            return {
                baseUrl: config.baseUrl,
                dialogFormVisible1:false,
                dialogFormVisible2:false,
                textarea1:'',
                transparent:'',
                waterWidth:'',
                waterHeight:'',
                rotate:'',
                watertext:'',
                types:'',
                margins:'',
                marginsNum:[],
                fill:'',
                strokeWidth:'',
                stroke:'',
                left:0,
                right:0,
                top:0,
                low:0,
                align:'',
                Walign:'',
                Wfill:'',
                linespacing:'',
                text:'',
                fontFamily:'',
                bold:false,
                italic:false,
                strikeout:false,
                underline:false,
                dialog: {                   // dialog显示隐藏
                    dialogDrag: true,       // 可拖拽
                    dialogChange: false,    // 可拉伸
                },
                shapes: [{
                    shape: 'rect',
                    label: '矩形'
                    }, {
                    shape: 'ellipse',
                    label: '圆'
                    }],
                shape: '',
                fonds: [{
                    fond: 0,
                    label: '底端对齐'
                    }, {
                    fond: 1,
                    label: '居中对齐'
                    },{
                    fond: 4,
                    label: '顶端对齐'
                    }],
                fond: '',
                Wfonds: [{
                    Wfond: 0,
                    label: '右对齐'
                    }, {
                    Wfond: 1,
                    label: '左对齐'
                    },{
                    Wfond: 2,
                    label: '居中对齐'
                    }],
                Wfond: '',
                fontSize:'',
                fontColor:'',
                customization: {
                    leftMenu: true,
                    rightMenu: true,
                    statusBar: true,
                    header: true,
                    isCompareWithUrl:false,
                    compareWithUrl:'',
                    // watermark:{
                    //   waterWidth:'',
                    //   waterHeight:'',
                    //   rotate:'',
                    //   types:'',
                    //   transparent:'',
                    //   text:'',
                    // }
                    
                },
                editIconList: [
                    {
                        mode: 'desktop',
                        title: 'PC端打开',
                        source: require("../assets/images/desktop-51-hover.png"),
                        isShow: ['text', 'spreadsheet', 'presentation'],
                    },
                    {
                        mode: 'review',
                        title: '修订模式',
                        source: require("../assets/images/review-51.png"),
                        isShow: ['text'],
                    },
                    {
                        mode: 'comment',
                        title: '批注模式',
                        source: require("../assets/images/comment-51.png"),
                        isShow: ['text', 'presentation'],
                    },
                    {
                        mode: 'content',
                        title: '局部编辑',
                        source: require("../assets/images/content-51.png"),
                        isShow: ['text'],
                    },
                    {
                        mode: 'filter',
                        title: '禁止筛选',
                        source: require("../assets/images/filter-51.png"),
                        isShow: ['spreadsheet'],
                    },
                    {
                        mode: 'mobile',
                        title: '移动端打开',
                        source: require("../assets/images/mobile-51.png"),
                        isShow: ['text', 'spreadsheet', 'presentation'],
                    },
                ],
                previewIconList: [
                    {
                        mode: 'preview',
                        title: 'PC端查看',
                        source: require("../assets/images/preview-51.png"),
                        isShow: ['text', 'spreadsheet', 'presentation'],
                    },
                    //{
                    //    mode: 'embedded',
                    //    title: '嵌入式查看',
                    //    source: require("../assets/images/embedded-51.png"),
                    //    isShow: ['text', 'spreadsheet', 'presentation'],
                    //},
                    {
                        mode: 'previewMobile',
                        title: '移动端查看',
                        source: require("../assets/images/previewMobile-51.png"),
                        isShow: ['text', 'spreadsheet', 'presentation'],
                    },
                ],
                iconSrcList: {
                    download: require("../assets/images/download-51.png"),
                    delete: require("../assets/images/delete-51.png"),
                },
                permission: {
                    comment: false,
                    copyoutenabled: false,
                    download: false,
                    edit: false,
                    print: false,
                    review: false,

                },
                showIcon: false,
                userLists: [
                    {
                        id: 'uid-1',
                        name: '用户1',
                    },
                    {
                        id: 'uid-2',
                        name: '用户2',
                    },
                    {
                        id: 'uid-3',
                        name: '用户3',
                    },
                    {
                        id: 'uid-4',
                        name: '用户4',
                    },
                    {
                        id: 'uid-5',
                        name: '用户5',
                    },
                ],
                viewModeList: [
                    {
                        id: '0',
                        mode: '标记状态',
                        code: 'markup'
                    },
                    {
                        id: '1',
                        mode: '最终状态',
                        code: 'final'
                    },
                    {
                        id: '2',
                        mode: '原始状态',
                        code: 'original'
                    },
                ],
                // 配置项参数
                selectlang: 'zh',
                selectUser: {
                    name: '张婷平',
                    id: 'uid-1'
                },
                selectUserId: 'uid-1',
                selectUserName: '张婷平',
                selectMode: 'desktop',
                selectReviewDisplay: 'markup',
                permissionCheckList: [],
                viewCtrlCheckList: ['工具栏', '左侧面板', '状态栏', '右侧面板',],
                fileName: '',
                fileType: '',
            }
             
        },
        created(){
            },
        methods: {
            actionCommand: function(command) {
                let item = this.viewModeList.find(e => e.id === command);
                let name = item['code'];
                this.selectReviewDisplay = name;
                
          },
          waterMarks: function(){
            this.onOpenFile(this.file.name, this.file.type)
            this.dialogFormVisible2=false
            console.log('水印设置')
          },
          encodeUrl: function (filename) {
            let href = this.baseUrl + '/download?fileName=' + encodeURIComponent(filename);
            var a = document.createElement('a');
            a.setAttribute('href', href);
            a.setAttribute('target', '_blank');
            a.setAttribute('id', 'js_a');
            //防止反复添加
            if (document.getElementById('js_a')) {
              document.body.removeChild(document.getElementById('js_a'));
            }
            document.body.appendChild(a);
            a.click();
            console.log(href,'href')
            console.log(this.file,'file')
          },
          Compare: function(){
            this.customization.isCompareWithUrl=true;
            this.customization.compareWithUrl=this.textarea1;
            this.onOpenFile(this.file.name, this.file.type)
            var name = encodeURIComponent(this.file.name);
            var url = this.baseUrl + "/file?filename=" + name;
            console.log(url,'url')
            this.textarea1=""
            this.dialogFormVisible1=false
            this.customization.isCompareWithUrl=false;

          },
            actionShowIcon: function() {
                this.showIcon = true;
            },
            actionHideIcon: function() {
              this.showIcon = false;
            },
          actionDelete: function () {
            var name = encodeURIComponent(this.file.name);
            var url = this.baseUrl + "/file?filename=" + name;
                axios.delete(url).then(r => {
                    console.log("删除成功")
                  this.$emit('onListDelete', this.file.name)
                })
            },
            actionToggleIcon: function(mode, index) {
                // log("click icon: ", mode, index)
                // 把上一个 icon hover 效果移除
                const tempStr = ''
                let icon = this.editIconList.find(e => e.mode === this.selectMode)
                if (!icon) {
                    icon = this.previewIconList.find(e => e.mode === this.selectMode)
                }
                if (icon === undefined) {
                    //
                } else {
                    icon["source"] = require(`../assets/images/${this.selectMode}-51${tempStr}.png`)
                }
                this.selectMode = mode;
            },
            actionToggleSrc: function(title, active) {
                const tempStr = active ? '-hover' : ''
                const icons = Object.keys(this.iconSrcList)
                if (icons.indexOf(title) > -1) {
                    this.iconSrcList[`${title}`] = require(`../assets/images/${title}-51${tempStr}.png`)
                } else {
                    return;
                }
            },
            changeIconSrc: function(title, active) {
                // log("鼠标移入/移除")
                const isSelect = this.selectMode === title
                const tempStr = active ? '-hover' : ''
                if (!active) {
                    if (isSelect)
                    return;
                }
                let icon = this.editIconList.find(e => e.mode === title)
                if (!icon) {
                    icon = this.previewIconList.find(e => e.mode === title)
                }
   
                if (icon === undefined) {
                    return
                } else {
                    // log("find icon: ", icon)
                    icon["source"] = require(`../assets/images/${title}-51${tempStr}.png`)
                }
            },
            setNumber:function(arr){
              var arrs=[]
              for(var i=0;i<arr.length;i++){
                arrs.push(Number(arr[i]))
              }
              return arrs
            },
          onOpenFile: function (file, type) {
                this.fileName = file;
                this.fileType = type;
                let query = {
                    // mode: this.editorMode,
                    mode: this.selectMode,
                    reviewDisplay: this.selectReviewDisplay,
                    fileName: this.fileName,
                    fileType: this.fileType,
                    userid: this.selectUser.id,
                    name: this.selectUser.name,
                    lang: this.selectlang,
                    waterWidth:this.waterWidth,
                    waterHeight:this.waterHeight,
                    rotate:this.rotate,
                    types:this.types,
                    transparent:this.transparent,
                    left:Number(this.left),
                    right:Number(this.right),
                    top:Number(this.top),
                    low:Number(this.low),
                    margins:this.margins.split(',',4),
                    waterfill:this.fill.split(','),
                    strokeWidth:this.strokeWidth,
                    stroke:this.stroke.split(','),
                    align:this.align,
                    Walign:this.Walign,
                    Wfill:this.Wfill.split(','),
                    linespacing:this.linespacing,
                    text:this.text,
                    shape:this.shape,
                    font:this.font,
                    Wfond:this.Wfond,
                    fontSize:this.fontSize,
                    fontFamily:this.fontFamily,
                    fondColor:this.fondColor,
                    bold:this.bold,
                    italic:this.italic,
                    strikeout:this.strikeout,
                    underline:this.underline,
                    fontColor:this.fontColor.split(','),
                    fond:this.fond,
                    // paragraphs:this.paragraphs,
                    compareWithUrl:this.customization.compareWithUrl,
                    isCompareWithUrl:this.customization.isCompareWithUrl,
                    leftMenu: this.viewCtrlCheckList.indexOf('左侧面板') > -1,
                    rightMenu: this.viewCtrlCheckList.indexOf('右侧面板') > -1,
                    statusBar: this.viewCtrlCheckList.indexOf('状态栏') > -1,
                    toolbar: this.viewCtrlCheckList.indexOf('工具栏') > -1,
                    download: !(this.permissionCheckList.indexOf('禁止下载') > -1),
                    print: !(this.permissionCheckList.indexOf('禁止打印') > -1),
                  copyoutenabled: !(this.permissionCheckList.indexOf('禁止复制') > -1),
                  
                }
                // log("this.fileName, this.fileType", this.fileName, this.fileType)
                // log("query in file item", query)
                var routeData = this.$router.resolve({
                    path: "/editor",
                    query: query
                });

                window.open(routeData.href, "_blank");
                console.log(query.italic,'italic')
                console.log(query.bold,'bold')
            },
            onChangeUser: function() {
                // log("this.selectUserName", this.selectUserName)
                log("this.selectUser", this.selectUser)
                // 配置重置
                this.permissionCheckList = [];
                this.viewCtrlCheckList = ['工具栏', '左侧面板', '状态栏', '右侧面板'];
                this.selectMode = 'desktop';
                this.selectReviewDisplay === 'markup';
            }
        },

    }
</script>

<style scoped>
    .checkbox-view {
        width: 210px;
        display: inline-block;
    }
    .class-table {
        display: table;
    }
    .table-row {
        display: table-row;
    }
    .table-cell {
        display: table-cell;
        width: 250px;
    }
    .cell-1 {
        width: 150px;
    }
    .cell-2 {
        width: 250px;
    }
    .cell-3 {
        width: 370px;
    }
    .cell-4 {
        width: 250px;
    }
    .cell-5 {
        width: 250px;
    }
    .cell-6 {
        text-align: right;
        width: 85px;
    }
  .font-width1{
    width:200px;
    float:left;
  }
  .font-width2{
    width:200px;
    float:left;
    margin-left:50px;
  }
  .font-aligning{
      margin-left:16px

  }
  .icon-width {
    width: 12px;
    vertical-align: baseline;
    display: inline-block;
  }
  .table-cell-view {
    display: flex;
    /*justify-content: space-evenly;*/
  }
    .tableHeaderCellView {
        width: 330px !important;
    }
    .stored-name-cell {
        position: relative;
        width: 250px;
    }
    .stored-edit {
        background-position: left center;
        background-repeat: no-repeat;
        display: inline-block;
        /*height: 16px;*/
        max-width: 129px;
        margin-bottom: -6px;
        overflow: hidden;
        /*padding: 8px 0 1px 34px;*/
        text-decoration: none;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
        font-size: 16px;
    }
    .stored-download {
        display: inline-block;
        /*float: right;*/
        right: 40px;
        margin-top: 4px;
        position: absolute;
    }

    .editor-config {

    }
    .editor-config:hover span {
        /*color: #61dafb;*/
    }
    .icon {
        margin-bottom: -6px;
        width: 23px;
        height: 23px;
        cursor: pointer;
    }
  .icon-code {
    margin-bottom: -6px;
    width: 23px;
    height: 23px;
    cursor: pointer;
    background-image: url(../assets/images/code-51.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .icon-code:hover {
    margin-bottom: -6px;
    width: 23px;
    height: 23px;
    cursor: pointer;
    background-image: url(../assets/images/code-51-hover.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
    .icon-container {
        display: inline-block;
        margin-left: 5px;
    }
    .el-dropdown:global {
        position: absolute;
    }
    .el-dropdown-link {
        cursor: pointer;
        font-size: 12px;
    }
    .el-dropdown-item {
        font-size: 12px;
    }
      .el-dropdown-item:hover {
        background-color: #F0F0F0;
        color: #66b1ff;
      }
  .el-select-dropdown__item.hover {
    background-color: #F0F0F0;
  }

</style>



// WEBPACK FOOTER //
// src/components/fileItem.vue